var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFocusOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "#3C3C3B",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/gps"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gps"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 4.25C7.27208 4.25 4.25 7.27208 4.25 11C4.25 14.7279 7.27208 17.75 11 17.75C14.7279 17.75 17.75 14.7279 17.75 11C17.75 7.27208 14.7279 4.25 11 4.25ZM2.75 11C2.75 6.44365 6.44365 2.75 11 2.75C15.5563 2.75 19.25 6.44365 19.25 11C19.25 15.5563 15.5563 19.25 11 19.25C6.44365 19.25 2.75 15.5563 2.75 11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 8.75C9.75736 8.75 8.75 9.75736 8.75 11C8.75 12.2426 9.75736 13.25 11 13.25C12.2426 13.25 13.25 12.2426 13.25 11C13.25 9.75736 12.2426 8.75 11 8.75ZM7.25 11C7.25 8.92893 8.92893 7.25 11 7.25C13.0711 7.25 14.75 8.92893 14.75 11C14.75 13.0711 13.0711 14.75 11 14.75C8.92893 14.75 7.25 13.0711 7.25 11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0.25C11.4142 0.25 11.75 0.585786 11.75 1V3C11.75 3.41421 11.4142 3.75 11 3.75C10.5858 3.75 10.25 3.41421 10.25 3V1C10.25 0.585786 10.5858 0.25 11 0.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 11C0.25 10.5858 0.585786 10.25 1 10.25H3C3.41421 10.25 3.75 10.5858 3.75 11C3.75 11.4142 3.41421 11.75 3 11.75H1C0.585786 11.75 0.25 11.4142 0.25 11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 18.25C11.4142 18.25 11.75 18.5858 11.75 19V21C11.75 21.4142 11.4142 21.75 11 21.75C10.5858 21.75 10.25 21.4142 10.25 21V19C10.25 18.5858 10.5858 18.25 11 18.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.25 11C18.25 10.5858 18.5858 10.25 19 10.25H21C21.4142 10.25 21.75 10.5858 21.75 11C21.75 11.4142 21.4142 11.75 21 11.75H19C18.5858 11.75 18.25 11.4142 18.25 11Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocusOn);
export default __webpack_public_path__ + "static/media/focusOn.a67350515fe5dc0f07607a19d54a0fe2.svg";
export { ForwardRef as ReactComponent };